import React, { useState, useEffect, useReducer, useContext } from "react";
import SiteLocation from "../siteMap/SiteLocation";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import _ from "lodash";
import sbgDetails from "../../reducers/sbgDetails";
import * as utils from "../../common/utils";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import { postUserLog } from "../../actions/common";
import * as actions from "../../actions/siteDetails";
import * as actionsCluster from "../../actions/cluster";
import atImg from "../../styles/assets/images/at.jpg";
import corporateImg from "../../styles/assets/images/corporate.jpg";
import baImg from "../../styles/assets/images/ba.jpg";
import essImg from "../../styles/assets/images/ess.jpg";
import iaImg from "../../styles/assets/images/ia.jpg";
import adminImg from "../../styles/assets/images/admin.jpg";
import Settings from "../settings/Settings";
import AdminConsole from "../adminConsole/AdminConsole";
import ClusterDetails from "../cluster/ClusterDetails";
import { Toast } from "devextreme-react/toast";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import config from "../../common/config";

//import FETCH_SBG_DATA from '../../actions/actionTypes';
const initialState = {
  sbgData: [],
  userData: null,
  clustersData: [],
};

export default (props) => {
  const devDisplayOptions = config.DEV_DISPLAY_OPTIONS;

  const navigate = useNavigate();
  const { category } = useParams();

  const bg = {
    Aero: atImg,
    CORP: corporateImg,
    BA: baImg,
    ESS: essImg,
    IA: iaImg,
    all: corporateImg,
    ADMIN: adminImg,
  };

  const [state, dispatch] = useReducer(sbgDetails, initialState);
  const { sbgData, userData, clustersData } = state;
  const userData1 = useSelector((state) => state.home);
  //const { router, match, location, routes, history } = props
  //const { match, history, location } = props
  //const { category } = match.params;
  const [active, setActive] = useState(category ? category : "CORP");
  const [activeSites, setActiveSites] = useState([]);
  const [isActiveSet, setIsActiveSet] = useState(
    !config.DEV_DISPLAY_OPTIONS ? true : false
  );
  const [siteCount, setSiteCount] = useState("");
  const [isAdminConsole, setIsAdminConsole] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "error",
    message: "",
  });
  const setActiveVal = (e) => {
    if (e.target.dataset && e.target.dataset.id) {
      if (e.target.dataset.id !== "all") {
        let sites = sbgData.filter((item) => {
          if (item.id == e.target.dataset.id) return item;
        });
        //   sbgData.map(
        //     (item) => "icon " + utils.getSbgName(item.id) + "-icon",
        //     "Testing"
        //   ),
        //   "sbgData",
        //   sbgData
        // );
        setActive(e.target.dataset.id);
        setSiteCount(sites[0].sites.length);
        setActiveSites(sites[0]["pinnedSites"]);
      }
    }
  };

  const showSites = (id, label) => {
    setIsActiveSet(true);
    setActive(id);
    postUserLog({
      event: "SBG Changed",
      data: {
        action: "SBG changed to " + label,
        module: "Landing Screen",
        section: "SBG Selection",
        siteUId: "HOME",
        widget: "",
      },
    });
  };
  const showAdminSettings = (id, label) => {
    setIsAdminConsole(true);
    setIsActiveSet(false);
    setActive(id);
    //history.push(`/adminconsole`);
    navigate("/adminconsole");
    postUserLog({
      event: "Admin Console Selected",
      data: {
        action: "Admin Console Navigation" + label,
        module: "Landing Screen",
        section: "Admin Console",
        siteUId: "HOME",
        widget: "",
      },
    });
  };
  const fetchSbgData = () => {
    let url = "Home/GetSiteDetails?sbgid=all&siteid=all",
      method = "get";
    AsyncCallHandler(url, method).then((res) => {
      if (!category) {
        setSiteCount(res.data[0]["sites"].length);
        setActiveSites(res.data[0]["pinnedSites"]);
      } else {
        let taggedList = res.data.filter((item) => {
          if (item.id == category) return item;
        });
        setActive(category);
        setSiteCount(taggedList[0]["sites"].length);
        setActiveSites(taggedList[0]["pinnedSites"]);
      }
      dispatch({ type: "FETCH_SBG_DATA", payload: res.data });
    });
  };

  useEffect(() => {
    fetchSbgData();
    actions.getUserData(dispatch, null);
    config.DEV_DISPLAY_OPTIONS &&
      actionsCluster.fetchUserCluster(dispatch, null);
  }, []);

  //cluster functionality

  const [isClusterActive, setIsClusterActive] = useState(false);
  const [selectedClusterData, setSelectedClusterData] = useState([]);
  const [selectedClusterName, setSelectedClusterName] = useState("");
  const [uniqueClusterNames, setUniqueClusterNames] = useState([]);
  const [isNewCluster, setIsNewCluster] = useState(false);

  const generateUniqueClusterNames = () => {
    let uniqueClusters = [];
    clustersData.forEach(
      (ele) =>
        !uniqueClusters.includes(ele.clusterName) &&
        uniqueClusters.push(ele.clusterName)
    );
    setUniqueClusterNames([...uniqueClusters]);
  };
  useEffect(() => {
    generateUniqueClusterNames();
  }, [clustersData]);

  const handleEditCluster = (clusterName) => {
    if (clusterName) {
      let _clustersData = clustersData.filter(
        (ele) => ele.clusterName === clusterName
      );
      setSelectedClusterData(_clustersData);
      setSelectedClusterName(clusterName);
    } else {
      setSelectedClusterData(selectedClusterData);
      setSelectedClusterName("");
    }
    setIsActiveSet(false);
    setIsClusterActive(true);
  };

  const handleNewCluster = () => {
    if (uniqueClusterNames.length < 2) {
      setIsNewCluster((cur) => !cur);
    } else {
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: "error",
        message: "Only Two Clusters Allowed",
      });
    }
  };

  const getSitesCount = (clusterName) => {
    let _clustersData = clustersData.filter(
      (ele) => ele.clusterName === clusterName
    );
    return _clustersData.length;
  };

  return (
    <>
      <Header redirect={() => setIsActiveSet(true)} />
      {!isActiveSet && !isClusterActive && (
        <section className="page-content">
          <div
            className="background-wrapper"
            style={{ backgroundImage: `url(${bg[active]})` }}
          ></div>
          <div className="menu-wrapper">
            <ul className="menus" onMouseOver={setActiveVal}>
              {sbgData &&
                sbgData.length > 0 &&
                sbgData.map((item) =>
                  item.id === "ADMIN" ? (
                    <li
                      onClick={() => showAdminSettings(item.id, item.label)}
                      className={active == item.id ? "current-node1" : ""}
                      key={item.id}
                      data-id={item.id}
                    >
                      <a>
                        <span className="icon customize-icon"></span>{" "}
                        {item.label}
                      </a>
                    </li>
                  ) : (
                    <li
                      onClick={() => showSites(item.id, item.label)}
                      key={item.id}
                      className={active == item.id ? "current-node1" : ""}
                      data-id={item.id}
                    >
                      <a>
                        <span
                          className={
                            "icon " + utils.getSbgName(item.id) + "-icon"
                          }
                        ></span>{" "}
                        {item.label}
                      </a>
                    </li>
                  )
                )}

              {/*<li onClick={() => showSites('ALL')} key={'all'} className={active == 'all' ? 'current-node1' : ''}data-id={'all'} ><a ><span ></span> All</a></li>*/}
            </ul>
            <ul className="menus" style={{ marginTop: ".5rem" }}>
              {uniqueClusterNames &&
                uniqueClusterNames.map((clusterName) => (
                  <li
                    key={clusterName}
                    onClick={() => handleEditCluster(clusterName)}
                    className=""
                  >
                    <a>
                      <span className="icon customize-icon"></span>
                      <span>{clusterName.toUpperCase()}</span>
                      <span>{getSitesCount(clusterName)} site</span>
                    </a>
                  </li>
                ))}
              {isNewCluster && (
                <li onClick={() => handleEditCluster()} className="">
                  <a>
                    <span className="icon add-icon"></span> {"EDIT CLUSTER"}{" "}
                  </a>
                </li>
              )}
              <li onClick={handleNewCluster} className="border-dashed">
                <a>
                  <span className="icon add-icon"></span> {"ADD CLUSTER"}
                </a>
              </li>
            </ul>
          </div>
        </section>
      )}
      {isActiveSet && !isClusterActive && <SiteLocation category={active} />}
      {isAdminConsole && <AdminConsole />}
      {!isActiveSet && isClusterActive && (
        <ClusterDetails
          category="CORP"
          data={selectedClusterData}
          selectedClusterName={selectedClusterName}
          uniqueClusterNames={uniqueClusterNames}
        />
      )}
      {/*{!isActiveSet && isClusterActive && <ClusterComponent clusterDetails={selectedClusterDetails} />}*/}
      <Footer
        showThemeSwitch={isActiveSet || isClusterActive}
        activeSites={activeSites}
        sbg={active}
        activeSiteCnt={siteCount}
      />
      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={() =>
          setToastConfig({
            ...toastConfig,
            isVisible: false,
          })
        }
        displayTime={2000}
      />
    </>
  );
};
